import React, { FC } from 'react';
import * as S from 'components/Forms/Forms.style';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  name: string;
  register?: any;
  rules?: object;
  errorMessage?: string;
}

export const NumberInput: FC<IProps> = ({
  label,
  name,
  register,
  rules,
  errorMessage,
  ...props
}) => {
  return (
    <S.FormItem>
      <label htmlFor={name}>{label}</label>
      <S.Input
        {...register?.(name, rules)}
        type="number"
        pattern="[0-9]*"
        {...props}
      />
      {errorMessage && <span>{errorMessage}</span>}
    </S.FormItem>
  );
};
